export default __webpack_public_path__ + "static/media/warning-mark.1e59cbf1.svg";